var map = {
	"./logo-01.png": "riHx",
	"./logo-02.png": "mEZt",
	"./logo-03.png": "5qrW",
	"./logo-04.png": "IZHV",
	"./logo-05.png": "Iuy/",
	"./logo-06.png": "h/Tw",
	"./logo-07.png": "mZkj",
	"./logo-08.png": "dQF/",
	"./logo-09.png": "b7ZA",
	"./logo-10.png": "BcGS",
	"./logo-11.png": "NZnZ",
	"./logo-12.png": "Aj5x",
	"./logo-13.png": "3MGJ",
	"./logo-14.png": "kCfM",
	"./logo-15.png": "p7PT",
	"./logo-16.png": "imBr",
	"./logo-17.png": "8mv+",
	"./logo-18.png": "GBQe",
	"./logo-19.png": "dtbF",
	"./logo-20.png": "xVge"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "saNK";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo ^\.\/logo\-.*\.png$
// module id = saNK
// module chunks = 1